import React from 'react';
import ReactDOM from 'react-dom/client';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Modal from 'react-modal';

import * as Sentry from '@sentry/react';
import classNames from 'classnames';

import './styles/fonts.css';
import { AsyncStylesheet } from './components/AsyncStylesheet/AsyncStylesheet';
import { rootStyleVariables } from './constants/rootStyleVariables';
import { RootContainer } from './containers/RootContainer/RootContainer';
import BwBold from './fonts/BwGradual-Bold.woff2';
import BwExtraBold from './fonts/BwGradual-ExtraBold.woff2';
import BwLight from './fonts/BwGradual-Light.woff2';
import BwMedium from './fonts/BwGradual-Medium.woff2';
import BwRegular from './fonts/BwGradual-Regular.woff2';
import SansationBold from './fonts/Sansation_Bold.ttf';
import SansationBoldItalic from './fonts/Sansation_Bold_Italic.ttf';
import SansationItalic from './fonts/Sansation_Italic.ttf';
import SansationLight from './fonts/Sansation_Light.ttf';
import SansationLightItalic from './fonts/Sansation_Light_Italic.ttf';
import SansationRegular from './fonts/Sansation_Regular.ttf';
import BasierCircleRegular from './fonts/basiercircle-regular-webfont.woff2';
import BasierCircleSemiBold from './fonts/basiercircle-semibold-webfont.woff2';
import './index.css';
import '@adyen/adyen-web/dist/adyen.css';

!!CONFIG.env.includes('live') && Sentry.init({
  dsn: 'https://b73b0426250d0b1e738e84d02dac4824@o1354268.ingest.sentry.io/4505680045342720',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['errors'],
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
  // We recommend adjusting this value in production.
  tracesSampleRate: 0.1,

  // Session Replay
  // This sets the sample rate at 0%. You may want to have it at 100% while in development
  // and then sample at a lower rate in production.
  replaysSessionSampleRate: 0,

  // If you're not already sampling the entire session, change the sample rate to 100%
  // when sampling sessions where errors occur.
  replaysOnErrorSampleRate: 0.002,

  environment: CONFIG.env,
  release: RELEASE,
});

Modal.setAppElement('.root');
const root = ReactDOM.createRoot(document.querySelector('.root') as Element);
root.render(
  <div className={classNames(rootStyleVariables[CONFIG.applicationSiteGroup])}>
    <link rel='preconnect' href='https://fonts.googleapis.com' />
    <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='' />
    <link rel='preconnect' href={CONFIG.staticImageUrl} />
    {CONFIG.applicationSiteGroup === 'CB' ? (
      <>
        <AsyncStylesheet
          href='https://fonts.googleapis.com/css2?family=Nunito:wght@700;800;900&display=swap'
        />
        <link
          rel='preload'
          as='font'
          href={BasierCircleRegular}
          type='font/woff2'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={BasierCircleSemiBold}
          type='font/woff2'
          crossOrigin='anonymous'
        />
      </>
    ) : null}
    {CONFIG.applicationSiteGroup === 'CK' ? (
      <>
        <AsyncStylesheet
          href='https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700&display=swap'
        />
        <link
          rel='preload'
          as='font'
          href={SansationBold}
          type='font/ttf'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={SansationBoldItalic}
          type='font/ttf'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={SansationItalic}
          type='font/ttf'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={SansationLight}
          type='font/ttf'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={SansationLightItalic}
          type='font/ttf'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={SansationRegular}
          type='font/ttf'
          crossOrigin='anonymous'
        />
      </>
    ) : null}
    {CONFIG.applicationSiteGroup === 'GCS' ? (
      <>
        <link
          rel='preload'
          as='font'
          href={BwRegular}
          type='woff2'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={BwBold}
          type='woff2'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={BwExtraBold}
          type='woff2'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={BwMedium}
          type='woff2'
          crossOrigin='anonymous'
        />
        <link
          rel='preload'
          as='font'
          href={BwLight}
          type='woff2'
          crossOrigin='anonymous'
        />
      </>
    ) : null}
    <RootContainer />
  </div>,
);
